import React from 'react';

interface ProcessResults {
  resume_tweaker?: any;
  skill_gap_analysis?: any;
  interview_questions?: any;
}

interface ResultsDisplayProps {
  results: ProcessResults;
  resumeText?: string;
  jobDescription?: string;
  onDownloadPDF?: (agentType: string) => void;
}

const ResultsDisplay: React.FC<ResultsDisplayProps> = ({ 
  results, 
  resumeText, 
  jobDescription, 
  onDownloadPDF 
}) => {
  const downloadText = (content: string, filename: string) => {
    const element = document.createElement('a');
    const file = new Blob([content], { type: 'text/plain' });
    element.href = URL.createObjectURL(file);
    element.download = filename;
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  const downloadPDF = async (agentType: string) => {
    if (onDownloadPDF) {
      onDownloadPDF(agentType);
    }
  };

  return (
    <div>
      <h2>📊 AI Analysis Results</h2>
      
      {results.resume_tweaker && (
        <div className="card" style={{ marginBottom: '20px' }}>
          <h3>📝 Improved Resume</h3>
          <div style={{ 
            backgroundColor: '#f8f9fa', 
            padding: '16px', 
            borderRadius: '6px',
            whiteSpace: 'pre-wrap',
            fontFamily: 'monospace',
            fontSize: '14px',
            maxHeight: '400px',
            overflowY: 'auto'
          }}>
            {results.resume_tweaker.improved_resume}
          </div>
          <div style={{ marginTop: '12px', display: 'flex', gap: '8px' }}>
            <button 
              className="btn" 
              onClick={() => downloadPDF('resume-tweaker')}
            >
              📄 Download Enhanced Resume PDF
            </button>
            <button 
              className="btn btn-secondary" 
              onClick={() => downloadText(results.resume_tweaker.improved_resume, 'improved_resume.txt')}
            >
              📝 Download Text
            </button>
          </div>
        </div>
      )}

      {results.skill_gap_analysis && (
        <div className="card" style={{ marginBottom: '20px' }}>
          <h3>🔍 Skill Gap Analysis</h3>
          <div style={{ 
            backgroundColor: '#f8f9fa', 
            padding: '16px', 
            borderRadius: '6px',
            whiteSpace: 'pre-wrap',
            fontSize: '14px',
            maxHeight: '400px',
            overflowY: 'auto'
          }}>
            {results.skill_gap_analysis.gap_analysis}
          </div>
          <div style={{ marginTop: '12px', display: 'flex', gap: '8px' }}>
            <button 
              className="btn" 
              onClick={() => downloadPDF('skill-gap-analysis')}
            >
              📄 Download Skill Gap PDF
            </button>
            <button 
              className="btn btn-secondary" 
              onClick={() => downloadText(results.skill_gap_analysis.gap_analysis, 'skill_gap_analysis.txt')}
            >
              📝 Download Text
            </button>
          </div>
        </div>
      )}

      {results.interview_questions && (
        <div className="card" style={{ marginBottom: '20px' }}>
          <h3>❓ Interview Questions</h3>
          <div style={{ 
            backgroundColor: '#f8f9fa', 
            padding: '16px', 
            borderRadius: '6px',
            whiteSpace: 'pre-wrap',
            fontSize: '14px',
            maxHeight: '400px',
            overflowY: 'auto'
          }}>
            {results.interview_questions.interview_questions}
          </div>
          <div style={{ marginTop: '12px', display: 'flex', gap: '8px' }}>
            <button 
              className="btn" 
              onClick={() => downloadPDF('interview-questions')}
            >
              📄 Download Interview Guide PDF
            </button>
            <button 
              className="btn btn-secondary" 
              onClick={() => downloadText(results.interview_questions.interview_questions, 'interview_questions.txt')}
            >
              📝 Download Text
            </button>
          </div>
        </div>
      )}

      <div className="alert alert-success">
        <strong>✅ Analysis Complete!</strong> All selected AI agents have processed your resume. 
        You can download individual results or use them to improve your job application.
      </div>
    </div>
  );
};

export default ResultsDisplay;
